<!-- <side-bar></side-bar> -->
<!-- <tandc-master-side-bar></tandc-master-side-bar> -->

<ng-container *ngIf="showAdminSidebar; else defaultSidebar">
    <tandc-master-side-bar></tandc-master-side-bar>
  </ng-container>
  <ng-template #defaultSidebar>
    <side-bar></side-bar>
  </ng-template>
  

<div id="mainContainer" class="main-container">
    <!-- <div class="fixed-top shadow-sm p-3 mb-5 bg-white rounded" id="topHeader">
        Hello I am Header
    </div> -->
    <router-outlet></router-outlet>
</div>